import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { DisplayField as Component } from './display-field';
import type { IProps } from './models';

export const DisplayField = createWidget<unknown, IProps>({})(Component);
